import React, { useState } from 'react';
import { NavLink, Link } from 'react-router-dom';

const links = [
  ['/mission', 'Mission'],
  ['/impact', 'Impact'],
  ['/careers', 'Get involved'],
];

const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="ai-header">
      <div className="ai-wrap">
        <Link to="/" className="ai-wordmark" aria-label="Afterimage Labs, home">
          <span className="ai-mark" aria-hidden="true" />
          <span>Afterimage <small>Labs</small></span>
        </Link>
        <button
          className="ai-menu-btn"
          aria-expanded={open}
          aria-controls="ai-nav"
          onClick={() => setOpen(!open)}
        >
          {open ? 'Close' : 'Menu'}
        </button>
        <nav id="ai-nav" className={`ai-nav ${open ? 'is-open' : ''}`}>
          {links.map(([to, label]) => (
            <NavLink key={to} to={to} onClick={() => setOpen(false)}>{label}</NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
};

export default Header;
